/* eslint-disable no-unused-vars -- known TS bug */
export enum ERROR_CODES {
  INTERNAL_ERROR = 500,
  NOT_FOUND = 404,
}

/* eslint-enable no-unused-vars */

export interface ApiProblemDetails {
  title: string;
  type: string;
  status: number;
  detail: string;
  instance: string;
  errorCode?: string;
  traceId?: string;
  timestamp?: string;
  requestPath?: string;
  requestMethod?: string;
}
